import { render } from "./basic-table.vue?vue&type=template&id=ef3f2d4c"
import script from "./basic-table.vue?vue&type=script&lang=js"
export * from "./basic-table.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__